import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  IconButton,
  FormControlLabel,
  Checkbox,
  FormLabel,
} from "@mui/material";

import CustomButton from "../../ui/FormFields/Button";
import { PinDrop, AssignmentInd } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import {
  AccountCircle,
  Email,
  Phone,
  LocationOn,
  Notifications,
  WhatsApp,
  Message,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import "../../../styles/UserStyles.css";
import { DASHBOARD, VENDOR_DASHBOARD } from "../Routes/AppRoutes";
import BusinessIcon from "@mui/icons-material/Business";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import {
  fetchUserRequest,
  resetUserDetails,
  updateUserRequest,
} from "../../../redux/ProfileUpdate/profileUpdateAction";
import { toast, ToastContainer } from "react-toastify";
import {
  selectCityRequest,
  selectCountryRequest,
  selectStateRequest,
} from "../../../redux/Common/selectorAction";
import { CUSTOMER_DASHBOARD } from "../Routes/CustomerRoutes";
import {
  fetchVendorDetailsRequest,
  resetVendorState,
  updateVendorRequest,
} from "../../../redux/Vendors/actions/vendorActions";
import {
  fetchCustomerDetailsRequest,
  resetCustomerState,
  updateCustomerRequest,
} from "../../../redux/Customers/actions/customerActions";
import {
  resetStaffDetail,
  staffUpdateRequest,
  StaffViewRequest,
} from "../../../redux/Staff/StaffAction";
import { useForm, Controller } from "react-hook-form";
import ControlledTextInputField from "../../ui/FormFields/ControlledTextInputField";
import Loading from "../../ui/Loading";
import DocumentViewer from "../../../Screens/Vendors/DocumentViewer";
import UseImageToBase64 from "../../../Screens/Vendors/UseImageToBase64";
import {
  convertDateFormat,
  convertDateOfBirthFormat,
  convertImageToBase64,
  formatDatetimeWithAMPM,
  isBase64,
} from "../../../Style";
import StatusRadioGroup from "../../ui/FormFields/StatusRadioGroup";

export default function ProfileUpdate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const successMessage = useSelector((state) => state.profile?.message || null);
  const loading = useSelector((state) => state.profile?.loading || null);
  const customerData = useSelector((state) =>
    user.role === "Customer" ? state.customers.customerDetails?.data?.data : {}
  );
  const [selectedFileName, setSelectedFileName] = useState("");

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setValue("documents", reader.result);
        setSelectedFileName(file.name);
      };
      reader.onerror = (error) => {
        console.error("Error converting file: ", error);
      };
    }
  };

  function extractBase64(input) {
    let result = input; // Get the part after "base64,"

    if (result && result.includes("base64")) {
      result = input.split(/base64,/i)[1];
    }
    if (result && result.includes("pngbase64")) {
      // Remove any unwanted non-Base64 characters before actual Base64 data
      result = result.split(/dataimage\/pngbase64/i)[1];
    }

    return result;
  }

  const vendorData = useSelector((state) =>
    user.role === "Vendor" ? state.vendors?.vendorDetails?.data : {}
  );
  const fetchedUser = useSelector((state) =>
    user.role === "Admin" ? state.profile.userProfile?.data?.data : {}
  );
  const userData = useSelector((state) =>
    user.role === "Staff" ? state.staffs?.Staff.data : {}
  );
  const success = useSelector((state) => state.vendors.vendorDetails.success);
  const customerSuccess =
    useSelector((state) => state.customers.success?.update) || false;
  const viewStaff = useSelector((state) => state.staffs?.Staff || {});
  const staffSuccessMessage = viewStaff?.updateSuccess;
  const errorMessage = viewStaff?.error;

  const {
    control,
    formState: { errors: error },
    watch,
    setError,
    setValue,
    reset,
    handleSubmit: formhandleSubmit,
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      address1: "",
      address2: "",
      country_code: "",
      pincode: "",
      city: "",
      state: "",
      country: "",
      nationality: "",
      gender_type: "",
      dob: "",
      passport_number: "",
      aadhar_number: "",
      status: "",
      agency_name: "",
      discount: "",
      pan_number: "",
      gstin_number: "",
      company_reg_number: "",
      proof_image: "",
      // Add notification preferences
      notification_email: true,
      notification_sms: true,
      notification_whatsup: true,
    },
  });

  useEffect(() => {
    if (user.role === "Customer") {
      dispatch(fetchCustomerDetailsRequest(user.customer_id));
    } else if (user.role === "Vendor") {
      dispatch(fetchVendorDetailsRequest(user.vendor_id));
    } else if (user.role === "Admin") {
      dispatch(fetchUserRequest(user.id));
    } else if (user.role === "Staff") {
      dispatch(StaffViewRequest(user.staff_id));
    }
  }, [user]);

  const formValue = watch();
  const countryId = formValue.country?.value;
  const stateId = formValue.state?.value;
  const stateCount = useRef(0);
  const cityCount = useRef(0);

  useMemo(() => {
    if (countryId > 0 && stateCount.current > 0) {
      setValue("state", "");
      setValue("city", "");
    }
    if (countryId > 0) {
      dispatch(selectStateRequest(countryId));
      stateCount.current += 1;
    }
  }, [countryId]);

  // change state
  useMemo(() => {
    if (stateId > 0 && cityCount.current > 0) {
      setValue("city", "");
    }
    if (stateId > 0) {
      dispatch(selectCityRequest(stateId));
      cityCount.current += 1;
    }
  }, [stateId]);

  useEffect(() => {
    if (userData?.id) {
      reset({
        first_name: userData?.first_name || "",
        last_name: userData?.last_name || "",
        phone: userData?.phone || "",
        email: userData?.email || "",
        address1: userData?.address1 || "",
        address2: userData?.address2 || "",
        country_code: userData?.country_code
          ? {
              label: `+${userData?.country_code}`,
              value: userData?.country_code,
            }
          : null,
        pincode: userData?.pincode || "",
        city: userData?.city
          ? {
              label: (userData?.city_name || "").replace("_", " "),
              value: userData?.city,
            }
          : null,
        state: userData?.state
          ? {
              label: (userData?.state_name || "").replace("_", " "),
              value: userData?.state,
            }
          : null,
        country: userData?.country
          ? {
              label: (userData?.country_name || "").replace("_", " "),
              value: userData?.country,
            }
          : null,
        status: userData?.status == 1 ? "Active" : "Inactive",
      });
    }
  }, [userData]);

  useEffect(() => {
    if (customerData?.id) {
      reset({
        first_name: customerData?.first_name || "",
        last_name: customerData?.last_name || "",
        phone: customerData?.phone || "",
        email: customerData?.email || "",
        address1: customerData?.address1 || "",
        address2: customerData?.address2 || "",
        country_code: customerData?.country_code
          ? {
              label: `+${customerData?.country_code}`,
              value: customerData?.country_code,
            }
          : null,
        pincode: customerData?.pincode || "",
        city: customerData?.city
          ? {
              label: (customerData?.city_name || "").replace("_", " "),
              value: customerData?.city,
            }
          : null,
        state: customerData?.state
          ? {
              label: (customerData?.state_name || "").replace("_", " "),
              value: customerData?.state,
            }
          : null,
        country: customerData?.country
          ? {
              label: (customerData?.country_name || "").replace("_", " "),
              value: customerData?.country,
            }
          : null,
        nationality: customerData?.familyMember?.nationality || "",
        gender_type: customerData?.familyMember?.gender_type || "",
        dob: formatDatetimeWithAMPM(customerData?.familyMember?.dob) || "",
        passport_number: customerData?.familyMember?.passport_number || "",
        aadhar_number: customerData?.familyMember?.aadhar_number || "",
        status: customerData?.status == 1 ? "Active" : "Inactive",
        // Set notification preferences - default to true (1) if not specified
        notification_email:
          customerData?.notification_email === 2 ? false : true,
        notification_sms: customerData?.notification_sms === 2 ? false : true,
        notification_whatsup:
          customerData?.notification_whatsup === 2 ? false : true,
      });
    }
  }, [customerData]);

  useEffect(() => {
    if (fetchedUser?.id) {
      reset({
        first_name: fetchedUser?.first_name || "",
        last_name: fetchedUser?.last_name || "",
        phone: fetchedUser?.phone || "",
        email: fetchedUser?.email || "",
        address1: fetchedUser?.UserProfile?.address1 || "",
        address2: fetchedUser?.UserProfile?.address2 || "",
        country_code: fetchedUser?.country_code
          ? {
              label: `+${fetchedUser?.country_code}`,
              value: fetchedUser?.country_code,
            }
          : null,
        pincode: fetchedUser?.UserProfile?.pincode || "",
        city: fetchedUser?.UserProfile?.city
          ? {
              label: (fetchedUser?.city_name || "").replace("_", " "),
              value: fetchedUser?.UserProfile?.city,
            }
          : null,
        state: fetchedUser?.UserProfile?.state
          ? {
              label: (fetchedUser?.state_name || "").replace("_", " "),
              value: fetchedUser?.UserProfile?.state,
            }
          : null,
        country: fetchedUser?.UserProfile?.country
          ? {
              label: (fetchedUser?.country_name || "").replace("_", " "),
              value: fetchedUser?.UserProfile?.country,
            }
          : null,
        status: fetchedUser?.status == 1 ? "Active" : "Inactive",
      });
    }
  }, [fetchedUser]);

  useEffect(() => {
    if (vendorData?.id) {
      reset({
        first_name: vendorData?.first_name || "",
        last_name: vendorData?.last_name || "",
        phone: vendorData?.phone || "",
        email: vendorData?.email || "",
        address1: vendorData?.address1 || "",
        address2: vendorData?.address2 || "",
        country_code: vendorData?.country_code
          ? {
              label: `+${vendorData?.country_code}`,
              value: vendorData?.country_code,
            }
          : null,
        pincode: vendorData?.pincode || "",
        city: vendorData?.city
          ? {
              label: (vendorData?.city_name || "").replace("_", " "),
              value: vendorData?.city,
            }
          : null,
        state: vendorData?.state
          ? {
              label: (vendorData?.state_name || "").replace("_", " "),
              value: vendorData?.state,
            }
          : null,
        country: vendorData?.country
          ? {
              label: (vendorData?.country_name || "").replace("_", " "),
              value: vendorData?.country,
            }
          : null,

        agency_name: vendorData?.agency_name || "",
        discount: vendorData?.discount || "",
        pan_number: vendorData?.pan_number || "",
        gstin_number: vendorData?.gstin_number || "",
        company_reg_number: vendorData?.company_reg_number || "",
        documents: vendorData.proof_image || "",
        status: vendorData?.status == 1 ? "Active" : "Inactive",
      });
      setSelectedFileName(vendorData.proof_image ? "Existing Document" : "");

      if (vendorData?.proof_image) {
        setSelectedFileName("Existing Document");
      }
    }
  }, [vendorData]);

  useEffect(() => {
    dispatch(resetCustomerState());
    dispatch(resetVendorState());
    dispatch(resetStaffDetail());
    dispatch(resetUserDetails());

    dispatch(selectCountryRequest());
  }, []);

  const countries = useSelector((state) => state.selector?.country?.data);
  const states = useSelector((state) => state.selector?.state?.data);
  const cities = useSelector((state) => state.selector?.city?.data);

  // country code fetcher
  const countryForCode = countries?.map((value) => {
    return {
      label: ` +${value.phonecode} - ${value.short_name}`,
      value: value.phonecode,
    };
  });

  const countryName = countries?.map((country) => {
    return { value: country?.id, label: country?.country_name };
  });

  const stateName = states?.map((state) => {
    return { value: state?.id, label: state?.state_name };
  });

  const cityName = cities?.map((city) => {
    return { value: city?.id, label: city?.city_name };
  });

  const userRole = user?.role;

  let dashboardUrl = DASHBOARD;
  if (userRole === "Vendor") {
    dashboardUrl = VENDOR_DASHBOARD;
  } else if (userRole === "Customer") {
    dashboardUrl = CUSTOMER_DASHBOARD;
  }

  useEffect(() => {
    if (successMessage || success || customerSuccess || staffSuccessMessage) {
      toast.success("Profile Updated Successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          successMessage || staffSuccessMessage
            ? navigate(dashboardUrl)
            : success
            ? navigate(VENDOR_DASHBOARD)
            : navigate(CUSTOMER_DASHBOARD);
          successMessage || staffSuccessMessage
            ? dispatch(resetUserDetails()) && dispatch(resetStaffDetail())
            : success
            ? dispatch(resetVendorState())
            : dispatch(resetCustomerState());
        },
      });
    }
  }, [successMessage, success, customerSuccess, staffSuccessMessage]);

  useEffect(() => {
    if (error) {
      if (error.message === "An error occurred") {
        toast.error("An error occured!", {
          autoClose: 3000,
          position: "top-center",
        });
      }
      if (error.message === "email must be unique") {
        setError("email", {
          type: "server",
          message: "Email must be unique",
        });
      }
      if (error.message === "contact must be unique") {
        setError("phone", {
          type: "server",
          message: "Contact must be unique",
        });
      }
    }
  }, [success, customerSuccess, error]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetStaffDetail());
        },
      });
    }
  }, [errorMessage]);

  const handleSubmit = async (data) => {
    try {
      // Convert image to base64 if documents exist
      const base64Image = data?.documents
        ? await convertImageToBase64(data.documents)
        : null;

      console.log("data", data);
      const updatedData = {
        ...data,
        country_code: data?.country_code.value,
        city: data.city?.value || userData?.city,
        state: data.state?.value || userData?.state,
        country: data.country?.value || userData?.country,
        id:
          vendorData?.id || customerData?.id || userData?.id || fetchedUser?.id,
        status: data.status === "Active" ? "1" : "0",
        profile_url: null,
        role_id: userData?.role_id || "",
        gender_type: data?.gender_type || userData?.gender_type || "",
        dob:
          convertDateOfBirthFormat(data?.dob) ||
          convertDateOfBirthFormat(userData?.dob) ||
          "",
        proof_image:
          data?.documents && isBase64(extractBase64(data.documents))
            ? extractBase64(data.documents)
            : extractBase64(base64Image),
      };

      if (userRole === "Customer") {
        updatedData.gender_type =
          data.gender_type || userData.gender_type || "";
        updatedData.dob =
          convertDateOfBirthFormat(data.dob) ||
          convertDateOfBirthFormat(userData.dob) ||
          "";
        updatedData.nationality = data.nationality || "";
        updatedData.passport_number = data.passport_number || "";
        updatedData.aadhar_number = data.aadhar_number || "";
        updatedData.display_name = customerData?.display_name || "";
        updatedData.user_id = customerData?.user_id;
        updatedData.user_type = "3";
        // Add notification preferences for customer
        updatedData.notification_email = data.notification_email ? 1 : 2;
        updatedData.notification_sms = data.notification_sms ? 1 : 2;
        updatedData.notification_whatsup = data.notification_whatsup ? 1 : 2;
      } else if (userRole === "Vendor") {
        updatedData.agency_name =
          data.agency_name || vendorData.agency_name || "";
        updatedData.discount = data.discount || vendorData.discount || "";
        updatedData.pan_number = data.pan_number || vendorData.pan_number || "";
        updatedData.gstin_number =
          data.gstin_number || vendorData.gstin_number || "";
        updatedData.company_reg_number =
          data.company_reg_number || vendorData.company_reg_number || "";

        if (
          data?.documents &&
          isBase64(extractBase64(data.documents)) &&
          typeof data?.documents === "string"
        ) {
          updatedData.proof_image = extractBase64(data.documents);
        } else if (vendorData.proof_image) {
          updatedData.proof_image = extractBase64(base64Image);
        } else {
          updatedData.proof_image = "";
        }

        updatedData.user_id = vendorData.user_id;
      }

      console.log("updatedData", updatedData);

      // Dispatch based on user role
      switch (userRole) {
        case "Customer":
          dispatch(updateCustomerRequest(updatedData, updatedData?.id));
          break;
        case "Vendor":
          dispatch(updateVendorRequest(updatedData, updatedData?.id));
          break;
        case "Admin":
          dispatch(updateUserRequest(updatedData));
          break;
        case "Staff":
          dispatch(staffUpdateRequest(updatedData, updatedData?.id));
          break;
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const documentsField = {
    name: "documents",
    label: "Upload Image *",
    type: "file",
    placeholder: "Upload your image",
    rules: {
      required: "Image upload is required",
      validate: {
        acceptedFormats: (files) => {
          if (!files || files.length === 0) return "Please upload an image";
          const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/jpg",
          ];
          return (
            allowedTypes.includes(files[0]?.type) ||
            "Only JPEG, PNG, GIF images are allowed"
          );
        },
      },
    },
    icon: <UploadFileIcon />,
    sm: 6,
    xs: 12,
    customRender: ({ name }) => (
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        sx={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "10px",
          backgroundColor: "white",
        }}
      >
        <input
          type="file"
          onChange={handleFileUpload}
          accept="image/jpeg,image/png,image/gif,image/jpg"
          style={{ display: "none" }}
          id="upload-documents"
        />
        <label htmlFor="upload-documents" style={{ flexGrow: 1 }}>
          <Button
            component="span"
            variant="outlined"
            startIcon={<UploadFileIcon />}
            sx={{
              textTransform: "none",
              width: "100%",
              justifyContent: "flex-start",
            }}
          >
            {selectedFileName ? selectedFileName : "Upload Image *"}
          </Button>
        </label>
        {selectedFileName && (
          <IconButton
            size="small"
            onClick={() => {
              setValue(name, null);
              setSelectedFileName("");
            }}
            sx={{
              marginLeft: 1,
              backgroundColor: "rgba(0,0,0,0.1)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.2)" },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    ),
  };
  const commonFormFields = [
    {
      name: "first_name",
      label: "First Name",
      placeholder: "Enter First Name",
      icon: <AccountCircle />,
      rules: { required: "First Name is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "last_name",
      label: "Last Name",
      placeholder: "Enter Last Name",
      icon: <AccountCircle />,
      rules: { required: "Last Name is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "country_code",
      options: countryForCode,
      label: "code",
      placeholder: "Select Country Code",
      rules: {
        required: "Code is Required",
      },
      sm: 2,
      xs: 4,
    },
    {
      name: "phone",
      label: "Mobile",
      placeholder: "Enter Mobile Number",
      icon: <Phone />,
      rules: {
        required: "Mobile Number is required",
        // pattern: {
        //   value: /^[6-9]\d{9}$/,
        //   message: 'Enter a valid Mobile Number',
        // },
      },
      sm: 4,
      xs: 8,
    },
    {
      name: "email",
      label: "Email",
      placeholder: "Enter Email Address",
      icon: <Email />,
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Enter a valid email address",
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "address1",
      label: "Address Line 1 *",
      placeholder: "Enter Address",
      type: "text",
      rules: { required: "Address Line 1 is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "address2",
      label: "Address Line 2",
      placeholder: "Enter Address",
      // rules: { required: 'Address Line 2 is required' },
      type: "text",
      sm: 6,
      xs: 12,
    },
    {
      name: "country",
      label: "Country *",
      placeholder: "select Country",
      type: "text",
      options: countryName,
      rules: { required: "Country is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "state",
      label: "State *",
      placeholder: "select State",
      type: "text",
      options: stateName,
      rules: { required: "State is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "city",
      label: "City *",
      placeholder: "select City",
      type: "text",
      options: cityName,
      rules: { required: "City is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "pincode",
      label: "Pincode",
      placeholder: "Enter Pincode",
      icon: <PinDrop />,
      rules: {
        required: "Pincode is required",
        // pattern: {
        //   value: /^[0-9]{4,8}$/,
        //   message: 'Enter a valid pincode (4-8 digits)',
        // },
      },
      sm: 6,
      xs: 12,
    },
  ];

  const customerFormFields = [
    {
      name: "nationality",
      label: "Nationality *",
      placeholder: "Enter Nationality",
      type: "text",
      rules: {
        required: "Nationality is required",
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Only alphabets are allowed",
        },
      },
      sm: 6,
      xs: 12,
      inputProps: {
        onInput: (e) => {
          e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
        },
      },
    },
    {
      name: "dob",
      label: "Date of Birth *",
      placeholder: "Select date of birth",
      type: "dob",
      rules: { required: "Date of Birth is required" },
      sm: 6,
      xs: 12,
    },

    {
      name: "passport_number",
      label: "Passport Number",
      placeholder: "Enter Passport Number",
      rules: {
        validate: {
          passportFormat: (value) => {
            if (!value || value.trim() === "") {
              return true;
            }
            const patterns = {
              US: /^[0-9]{9}$/,
              UK: /^[0-9]{9}$|^[A-Z]{2}[0-9]{7}$/,
              EU: /^[A-Z]{1,2}[0-9]{5,7}$/,
              CA: /^[A-Z]{2}[0-9]{6}$/,
              AU: /^[A-Z][0-9]{8}$/,
              IN: /^[A-Z][0-9]{7}$/,
              general: /^[A-Z0-9]{5,12}$/i,
            };

            return (
              patterns.US.test(value) ||
              patterns.UK.test(value) ||
              patterns.EU.test(value) ||
              patterns.CA.test(value) ||
              patterns.AU.test(value) ||
              patterns.IN.test(value) ||
              patterns.general.test(value) ||
              "Please enter a valid passport number"
            );
          },
        },
      },
      xs: 12,
      sm: 6,
    },
    {
      name: "aadhar_number",
      label: "Aadhar Number",
      placeholder: "Enter Aadhar Number",
      type: "Number",
      rules: {
        pattern: {
          value: /^\d{12}$/,
          message: "Aadhar Number must be exactly 12 digits",
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "gender_type",
      label: "Gender",
      placeholder: "Select Gender",
      icon: <AssignmentInd />,
      type: "radio",
      radioOptions: [
        { value: "M", label: "Male" },
        { value: "F", label: "Female" },
        { value: "O", label: "Other" },
      ],
      rules: { required: "Gender is required" },
      sm: 6,
      xs: 12,
    },
  ];

  const vendorFormFields = [
    {
      name: "agency_name",
      label: "Agency / Company Name",
      placeholder: "Enter Agency Name",
      icon: <BusinessIcon />,
      rules: { required: "Agency / Company Name is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "discount",
      label: "Vendor Commission",
      placeholder: "Enter Vendor Commission",
      rules: {
        required: "Vendor Commission is required",
        min: { value: 0, message: "Commission cannot be less than 0%" },
        max: { value: 100, message: "Commission cannot exceed 100%" },
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
  ];

  const indiaSpecificFields = [
    {
      name: "pan_number",
      label: "PAN Number",
      placeholder: "Enter PAN number",
      rules: {
        required: "PAN number is required",
        pattern: {
          value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          message: "Invalid PAN format (e.g., ABCDE1234F)",
        },
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "gstin_number",
      label: "GSTIN Number",
      placeholder: "Enter GSTIN number",
      rules: {
        required: "GSTIN number is required",
        pattern: {
          value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
          message: "Invalid GSTIN format (e.g., 22ABCDE1234F1Z5)",
        },
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
    documentsField,
  ];

  const companyRegField = [
    {
      name: "company_reg_number",
      label: "Company Registration Number",
      placeholder: "Enter Company Reg number",
      rules: {
        required: "Company Reg number is required",
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
    documentsField,
  ];

  let formFields = commonFormFields;

  if (userRole === "Customer") {
    formFields = [...commonFormFields, ...customerFormFields];
  } else if (userRole === "Vendor") {
    formFields = [...commonFormFields, ...vendorFormFields];

    const countryId = formValue.country?.value;
    if (countryId) {
      if (countryId === 101) {
        formFields = [...formFields, ...indiaSpecificFields];
      } else {
        formFields = [...formFields, ...companyRegField];
      }
    }
  }

  if (loading) {
    return <Loading text="Loading User Profile detail..." />;
  }

  return (
    <>
      <ToastContainer />
      <Box className="role-permission-container">
        <Card>
          <CardContent>
            <form onSubmit={formhandleSubmit((data) => handleSubmit(data))}>
              <Typography
                variant="h5"
                gutterBottom
                className="profile-subtitle"
              >
                Profile
              </Typography>

              <Grid container spacing={2}>
                {formFields.map((field, index) => (
                  <Grid item xs={field.xs} sm={field.sm} key={index}>
                    {field.customRender ? (
                      field.customRender({
                        name: field.name,
                        control: control,
                        label: field.label,
                        placeholder: field.placeholder,
                        startAdornment: field.icon,
                        radioOptions: field.radioOptions,
                        rules: field.rules,
                        type: field.type,
                        options: field.options,
                        error: !!error[field.name],
                        helperText: error[field.name]?.message,
                      })
                    ) : (
                      <ControlledTextInputField
                        name={field.name}
                        control={control}
                        label={field.label}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        rules={field.rules}
                        type={field.type}
                        options={field.options}
                        radioOptions={field.radioOptions}
                        error={!!error[field.name]}
                        helperText={error[field.name]?.message}
                      />
                    )}
                  </Grid>
                ))}

                {user.role === "Vendor" && (
                  <DocumentViewer fileUrl={vendorData?.proof_image} />
                )}
                <Grid item xs={12} sm={6}>
                  <StatusRadioGroup
                    name="status"
                    control={control}
                    defaultValue={"Active"}
                    disabled={true}
                  />
                </Grid>
              </Grid>
              {user.role === "Customer" && (
                <Grid item xs={12}>
                  <Box sx={{ mt: 2, mb: 2 }}>
                    <FormLabel
                      component="legend"
                      sx={{ fontWeight: "bold", mb: 2 }}
                    >
                      <Notifications sx={{ mr: 1, verticalAlign: "middle" }} />
                      Notification Preferences
                    </FormLabel>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <Controller
                          name="notification_email"
                          control={control}
                          defaultValue={true}
                          render={({ field }) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  {...field}
                                  checked={field.value}
                                  onChange={(e) =>
                                    field.onChange(e.target.checked)
                                  }
                                  color="primary"
                                />
                              }
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Email sx={{ mr: 1, fontSize: 20 }} />
                                  Email Notifications
                                </Box>
                              }
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Controller
                          name="notification_sms"
                          control={control}
                          defaultValue={true}
                          render={({ field }) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  {...field}
                                  checked={field.value}
                                  onChange={(e) =>
                                    field.onChange(e.target.checked)
                                  }
                                  color="primary"
                                />
                              }
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Message sx={{ mr: 1, fontSize: 20 }} />
                                  SMS Notifications
                                </Box>
                              }
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Controller
                          name="notification_whatsup"
                          control={control}
                          defaultValue={true}
                          render={({ field }) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  {...field}
                                  checked={field.value}
                                  onChange={(e) =>
                                    field.onChange(e.target.checked)
                                  }
                                  color="primary"
                                />
                              }
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <WhatsApp sx={{ mr: 1, fontSize: 20 }} />
                                  WhatsApp Notifications
                                </Box>
                              }
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}
              <Box className="button-container">
                <Button
                  variant="contained"
                  className="cancel-button"
                  onClick={() => {
                    dispatch(resetUserDetails());
                    navigate(dashboardUrl);
                  }}
                >
                  CANCEL
                </Button>
                <CustomButton
                  variant="contained"
                  className="success-button"
                  type="submit"
                  disabled={loading}
                  text={"UPDATE"}
                />
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
